import React, { Component } from "react";
import { Route, Switch } from "react-router-dom";
import Login from "../login/login";
import DashBoard from "../dashboard/dashboard";
import ProtectedRoutes from "../protectedroutes";
import TrackVehicle from "../trackvehicle/trackvehicle";

class StateApp extends Component {
  state = {
    logInfo: {
      isLogged: false,
      token: null,
    },
  };
  onHandleLogin = (authToken, username) => {
    const token = authToken === undefined ? null : authToken;
    const isLogged = authToken === undefined ? false : true;
    localStorage.setItem("auth-token", token);
    localStorage.setItem("username", username);
    this.setState({ logInfo: { isLogged, token } });
  };

  onHandleLogout = () => {
    localStorage.removeItem("auth-token");
    this.setState({ logInfo: { isLogged: false, token: null } });
  };

  render() {
    return (
      <Switch>
        <Route
          path="/login"
          component={(props) => (
            <Login handleLogin={this.onHandleLogin} {...props} />
          )}
        />
        <ProtectedRoutes
          path="/"
          component={(props) => (
            <DashBoard handleLogout={this.onHandleLogout} {...props} />
          )}
        />
      </Switch>
    );
  }
}

export default StateApp;
